import { Pencil, Trash2 } from "lucide-react";
import { allocationsOf, money, tryValue } from "../lib/format";
import { fmtDisplay } from "../lib/currency";
import { useAuth } from "../context/AuthContext";

export const CollectionTable = ({ collections, currency, rates, rate, onEdit, onDelete }) => {
  const { can } = useAuth();
  return (
    <div className="table-wrap collection-table-wrap" data-testid="collection-table-wrap">
      <table className="collection-table" data-testid="collection-table">
        <thead><tr><th>Tarih</th><th>Ödeyen</th><th>Ödenen</th><th>Dağıtım (hesaplar)</th><th>Açıklama</th><th>Yöntem</th><th className="right">Tutar</th><th className="right">{currency} karşılığı</th><th>İşlem</th></tr></thead>
        <tbody>
          {collections.map(c => (
            <tr key={c.id} data-testid={`collection-row-${c.id}`}>
              <td data-label="Tarih" data-testid={`collection-date-${c.id}`}>{c.collection_date}</td>
              <td data-label="Ödeyen" data-testid={`collection-payer-${c.id}`}><b>{c.payer || "—"}</b></td>
              <td data-label="Ödenen" data-testid={`collection-payee-${c.id}`}><b>{c.payee || "—"}</b></td>
              <td data-label="Dağıtım" data-testid={`collection-account-${c.id}`}>
                {allocationsOf(c).length ? allocationsOf(c).map(a => (
                  <span className="group-tag income" key={a.account} data-testid={`collection-allocation-${c.id}-${a.account}`}>{a.account} · {money(a.amount, c.currency)}</span>
                )) : <small className="hint">Atanmamış</small>}
              </td>
              <td data-label="Açıklama" data-testid={`collection-description-${c.id}`}><b>{c.description || c.customer || "—"}</b>
                {c.income_description && <small className="sub-line">Gelir: {c.income_description}</small>}
              </td>
              <td data-label="Yöntem" data-testid={`collection-method-${c.id}`}><span className="group-tag">{c.method}</span></td>
              <td data-label="Tutar" className="right amount income" data-testid={`collection-amount-${c.id}`}>{money(c.amount, c.currency)}</td>
              <td data-label={`${currency} karşılığı`} className="right amount income" data-testid={`collection-display-${c.id}`}>
                {fmtDisplay(tryValue(c, rate), currency, rates)}
                {c.currency !== "TRY" && <small className="sub-line">{c.amount.toLocaleString("tr-TR")} {c.currency} × {(c.currency_rate || c.rate || 0).toFixed(4)}</small>}
              </td>
              <td data-label="İşlem" className="row-actions">
                {can("edit") && <button type="button" className="icon-btn" title="Tahsilatı düzenle" data-testid={`edit-collection-${c.id}`} onClick={() => onEdit(c)}><Pencil size={15}/></button>}
                {can("delete") && <button type="button" className="icon-btn danger" title="Tahsilatı sil" data-testid={`delete-collection-${c.id}`} onClick={() => onDelete(c)}><Trash2 size={15}/></button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!collections.length && <div className="empty-table" data-testid="collections-empty">Seçili dönem ve filtrelere uygun tahsilat yok.</div>}
    </div>
  );
};